import { Link as RouterLink } from '@tanstack/react-router';

import {
  Card,
  Link,
  Grid,
  Stack,
  Button,
  Typography,
  CardContent,
} from '@mui/material';

import { paths } from 'src/routes/paths';

import {
  OrderIssueType,
  ProductIssueType,
  OrderIssueLogModel,
  OrderIssueResolutionType,
  ProductIssueResolutionType,
} from 'src/api/models/orders';

import IssueStatus from 'src/components/issue-log/issue-status';

// Re-introducing the IssueCard component for mobile view
interface IssueCardProps {
  issue: OrderIssueLogModel;
}

function IssueCard({ issue }: IssueCardProps) {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="body1">
                PO Number:{' '}
                <Link
                  component={RouterLink}
                  href={paths.dashboard.orders.orderDetails(issue.orderId)}
                >
                  {issue.orderReferenceNumber}
                </Link>
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {new Date(issue.createdOn).toLocaleDateString()}
              </Typography>
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <Stack spacing={1}>
              <Typography variant="body2" color="text.secondary">
                <b>Supplier:</b> {issue.distributorName || 'N/A'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <b>Issue Type:</b>{' '}
                {OrderIssueType[Number(issue.issueType)] ||
                  ProductIssueType[Number(issue.issueType)]}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <b>Product:</b> {issue.productName ? `${issue.productName}${issue.units ? ` (${issue.units})` : ''}` : 'Whole Order'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <b>Requested Resolution:</b>{' '}
                {OrderIssueResolutionType[Number(issue.resolutionType)] ||
                  ProductIssueResolutionType[Number(issue.resolutionType)]}
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <IssueStatus issue={issue} /> {/* Integrate IssueStatus component */}
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="outlined"
              component={RouterLink}
              to={paths.dashboard.issues.issueDetails(issue.orderId, issue.issueId)}
            >
              Issue Details
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default IssueCard;
